const localStorageKey = 'attendedPresentations'

/**
 * Attended Presentation example
 * @typedef {Object} AttendedPresentation
 * @property {String} id - Presentation ID
 * @property {String} name - Presentation name,
 * @property {String} thumbnailImage
 * @property {String} customThumbnailImage
 * @property {Date} joinAt
 * @property {String} accessCode
 * @property {String} uniqueAccessCode - Presentation unique access code
 * @property {String} audienceId
 * @property {Number} userId
 * @property {Boolean} isQuizEnd
 * @property {Number} maxLookbackSlideIndex
 * @property {Number} currentSharingSlideIndex
 */

const getAttendedPresentations = () => {
  return JSON.parse(localStorage.getItem(localStorageKey)) || []
}

const addAttendedPresentation = (object) => {
  const attendedPresentations = getAttendedPresentations()
  attendedPresentations.push(object)
  localStorage.setItem(localStorageKey, JSON.stringify(attendedPresentations))
}

const hasAttendedPresentation = (uniqueAccessCode) => {
  return getAttendedPresentations().some((item) => item.uniqueAccessCode === uniqueAccessCode)
}

const findAttendedPresentationsByUserId = (userId) => {
  return getAttendedPresentations().filter((item) => item.userId === userId)
}

const findAttendPresentationByUniqueAccessCode = (uniqueAccessCode) => {
  return getAttendedPresentations().find((item) => item.uniqueAccessCode === uniqueAccessCode)
}

const updateAttendedPresentation = (uniqueAccessCode, object) => {
  const attendedPresentations = getAttendedPresentations()
  const index = attendedPresentations.findIndex((item) => item.uniqueAccessCode === uniqueAccessCode)
  attendedPresentations[index] = object
  localStorage.setItem(localStorageKey, JSON.stringify(attendedPresentations))
}

// for lookback
const getValueByPresentationUniqueAccessCode = (uniqueAccessCode, key) => {
  const attendedPresentation = findAttendPresentationByUniqueAccessCode(uniqueAccessCode)

  return attendedPresentation ? attendedPresentation[key] : null
}

const setValueByPresentationUniqueAccessCode = (uniqueAccessCode, key, value) => {
  const attendedPresentation = findAttendPresentationByUniqueAccessCode(uniqueAccessCode)
  if (!attendedPresentation) return

  attendedPresentation[key] = value
  updateAttendedPresentation(uniqueAccessCode, attendedPresentation)
}

const deleteValueByPresentationUniqueAccessCode = (uniqueAccessCode, key) => {
  const attendedPresentation = findAttendPresentationByUniqueAccessCode(uniqueAccessCode)
  if (!attendedPresentation) return

  delete attendedPresentation[key]
  updateAttendedPresentation(uniqueAccessCode, attendedPresentation)
}

const getAudienceIdByPresentationUniqueAccessCode = (uniqueAccessCode) => {
  return getValueByPresentationUniqueAccessCode(uniqueAccessCode, 'audienceId')
}

export {
  getAttendedPresentations,
  addAttendedPresentation,
  hasAttendedPresentation,
  findAttendedPresentationsByUserId,
  findAttendPresentationByUniqueAccessCode,
  updateAttendedPresentation,
  getValueByPresentationUniqueAccessCode,
  setValueByPresentationUniqueAccessCode,
  deleteValueByPresentationUniqueAccessCode,
  getAudienceIdByPresentationUniqueAccessCode,
}
